import {
  On3IconAppleAppStore,
  On3IconGooglePlay,
  On3IconLogoRedSquare,
} from '@on3/icons';
import { useSite } from '@on3/ui-lib/index';
import { FanSiteAvatar } from '@public/components/Image/FanSiteAvatar';
import { Text } from '@public/components/UI/Typography/Text';
import clsx from 'clsx';
import { useMemo } from 'react';

import styles from './On3AppPromo.module.scss';

interface AppPromoProps {
  responsive?: boolean;
}

export const On3AppPromo = ({ responsive = true }: AppPromoProps) => {
  const { currentSite } = useSite();

  const teamName =
    currentSite?.organization?.knownAs ??
    currentSite?.organization?.name ??
    'On3';
  const mascot = currentSite?.organization?.mascot || 'team';
  const isRivals = currentSite?.resourceId?.includes('R_');
  const isSoftballAmerica = currentSite?.key === 401;
  const isTeam = currentSite?.isTeam && !isSoftballAmerica;
  const imageKey = isTeam && !isRivals ? currentSite?.key : 0;

  const teamStyle = useMemo(() => {
    return { backgroundColor: currentSite?.primaryColor || '#fff' };
  }, [currentSite?.primaryColor]);

  return (
    <section
      className={clsx(styles.on3AppSection, {
        [styles.responsive]: responsive,
      })}
    >
      <div className={styles.on3AppContainer}>
        <img
          alt="On3 App"
          className={styles.siteImage}
          height={244}
          src={`https://on3static.com/static/on3/app/${imageKey}-app.png`}
          width={395}
        />
        <div className={styles.details}>
          <div className={styles.appHeader}>
            {isTeam ? (
              <div className={styles.teamIcon} style={teamStyle}>
                <FanSiteAvatar height={50} width={50} />
              </div>
            ) : (
              <On3IconLogoRedSquare height={50} width={50} />
            )}
            <h2>App</h2>
          </div>
          <Text className={styles.body}>
            {`Get the ultimate ${teamName} experience with the On3 App. Trusted news,
        analysis, and real-time alerts for your ${mascot}. Stay informed like never
        before.`}
          </Text>
          <div className={styles.appStoreLinks}>
            <a href="https://apps.apple.com/us/app/on3-app/id1629727374">
              <On3IconAppleAppStore height={26} width={26} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.on3">
              <On3IconGooglePlay height={26} width={26} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
